import React from 'react';
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { AggregationType } from '../../../types/AggregationType';
import classNames from "classnames";

import "./BaseFacet.scss";

export type BaseFacetProps = {
  // Facet title
  title: string;
  // Facet type (e.g. 'keyword', 'daterange').
  type: AggregationType;
  // Total count of results for this facet
  totalCount: number;
  hasSelection: boolean
}

/**
 * Component intended to wrap concrete facet implementations. It provides a visual representation
 * and base functionality for each facet. Like e.g. each facet has its own container which can be
 * collapsed and it has a title and a body. Concrete facet implementations are provided with
 * data and their implementation is wrapped in the facet's body.
 */
class BaseFacet extends React.Component<BaseFacetProps> {

  render() {
    const {title, totalCount} = this.props;
    const headerClasses = classNames("facet-title", {
      selected: this.props.hasSelection
    });
    return <Accordion className="BaseFacet mb-3" data-title={title}>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey={title} className={headerClasses}>
          <div className="d-flex justify-content-between">
            <div className="facet-name text-truncate" title={title}>{title}</div>
            <div className="total-count">({totalCount})</div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={title} className="facet-body">
          <Card.Body>{this.props.children}</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  }
}

export default BaseFacet;
